<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo"><img width="80" src="assets/img/logo.png" alt="Logo"></a>
    </div>

    <div class="side-nav-responsive">
        <div class="container">
            <div class="dot-menu">
                <div class="circle-inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div>
            
            <div class="container">
                <div class="side-nav-inner">
                    <div class="side-nav text-start">
                          <div class="side-item">
                            <div class="user-btn">
                                <ul class="navbar-nav m-auto text-start">
                                    <a routerLink="/sign-in" style="cursor: pointer;" *ngIf="!isLogged"  class="nav-link"><i class='bx bxs-user'></i> Login / Register</a>
                                    <a class="nav-link" href="tel:{{phoneNumber}}"><i class='bx bxs-phone'></i> Call Us</a>
                                    <a routerLink="/account" *ngIf="isLogged" class="nav-link"><i class='bx bx-user'></i> My Account</a>
                                    <a routerLink="/account" *ngIf="isLogged" class="nav-link"><i class='bx bx-list-ol'></i> My Orders</a>
                                    <a routerLink="/cart" class="nav-link"><i class='bx bx-cart'></i> Cart</a>
                                    <a routerLink="/wishlist" class="nav-link"><i class='bx bx-heart'></i> Wishlist</a>
                                    <a style="cursor: pointer;" (click)="logOut()" *ngIf="isLogged" class="nav-link"><i class='bx bx-door-open'></i> Sing Out</a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Top Section -->
    <div class="top-nav-section">
        <div class="container-fluid">
            <div class="row align-items-center">
                <!-- Logo on the left -->
                <div class="col-md-3">
                    <a class="navbar-brand" routerLink="/">
                        <img width="120" src="assets/img/logo.png" alt="Logo">
                    </a>
                </div>
                
                <!-- Search input in the middle -->
                <div class="col-md-4">
                    <!-- <div class="search-btn w-100">
                        <div class="input-group">
                            <div class="input-group-append d-flex">
                                <span style="background-color: #E2292C;" class="input-group-text"><i class="bx bx-search"></i></span>
                            </div>
                            <input type="search" class="form-control border-0 ps-2" placeholder="Search..." aria-label="Search">
                        </div>
                    </div> -->
                </div>
                
                <!-- Icons on the right -->
                <div class="col-md-5">
                    <div class="d-flex justify-content-end align-items-center">
                        <div class="menu-btn" *ngIf="isLogged">
                            <div class="user-btn">
                                <ul class="navbar-nav">

                                    <li class="nav-item dropdownItem p-0" id="userBtnHover">
                                        <a href="javascript:void(0)" class="nav-link phone-btn">
                                            <i class='bx bxs-user'></i>
                                        </a>
                                        <ul class="dropdown-menu" style="background-color: #003921 !important;">
                                            <li class="nav-item">
                                                <a routerLink="/account" class="nav-link" routerLinkActive="active">Profile</a>
                                            </li>
                                            <li class="nav-item">
                                                <a routerLink="/account" class="nav-link" routerLinkActive="active">My Orders</a>
                                            </li>
                                            <li class="nav-item">
                                                <a (click)="logOut()" class="nav-link" routerLinkActive="active">Sign Out</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="menu-btn">
                            <a *ngIf="!isLogged" class="nav-link phone-btn" routerLink="/sign-in">
                                Login / Register
                            </a>
                        </div>
                        
                        <div class="menu-btn vibration">
                            <a href="tel:{{phoneNumber}}" class="phone-btn"><i class='bx bxs-phone'></i></a>
                        </div>

                        <div class="menu-btn vibration">
                            <a routerLink="/cart" class="phone-btn"><i class='bx bx-cart'></i></a>
                        </div>

                        <div class="menu-btn vibration">
                            <a routerLink="/wishlist" class="phone-btn"><i class='bx bx-heart'></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Bottom Section -->
    <div class="bottom-nav-section main-nav">
        <div class="container-fluid">
            <nav class="navbar navbar-expand-md navbar-light pt-0 pb-0">
                <div class="collapse navbar-collapse mean-menu justify-content-center">
                    <ul class="navbar-nav">
                        <li class="nav-item" [class.active]="isActive('/', true)">
                            <a routerLink="/" class="nav-link">Home</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('/about')">
                            <a routerLink="/about" class="nav-link">About us</a>
                        </li>

                        <li class="nav-item dropdownItem ">
                            <a href="javascript:void(0)" class="nav-link phone-btn">
                                Menu <i class='bx bxs-chevron-down'></i>
                            </a>
                            <ul class="dropdown-menu" style="background-color: #003921 !important;">
                                <li class="nav-item">
                                    <a routerLink="/menu/maincategory/2/catering" class="nav-link" [class.active]="isActive('/menu/maincategory/2/catering')">Catering</a>
                                </li>
                                <!-- <li class="nav-item">
                                    <a routerLink="/mainMenu" class="nav-link" [class.active]="isActive('/mainMenu')">Lunch</a>
                                </li> -->
                                <li class="nav-item">
                                    <a routerLink="/mainMenu" class="nav-link" [class.active]="isActive('/mainMenu')">Main Menu</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item" [class.active]="isActive('/order-apps')">
                            <a routerLink="/order-apps" class="nav-link">Order Apps</a>
                        </li>
                        <li class="nav-item" [class.active]="isActive('/offers')">
                            <a routerLink="/offers" class="nav-link">Offers</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>